import type { ActionsOfCreators, FeatureHandler } from '../helpers';
import { update } from './update';
import { hilStatus } from './hilStatus';
import { expired } from './expired';

export const outputActions = [update, hilStatus, expired];

export type OutputActions = ActionsOfCreators<typeof outputActions>;

export type Handler<T extends OutputActions> = FeatureHandler<T, OutputActions>;
